import {
  createSuccess as createAvailabilitySuccess,
  deleteSuccess as deleteAvailabilitySuccess,
  updateSuccess as updateAvailabilitySuccess,
} from 'FRONTEND/reducers/availabilitySlice';
import {
  clearForm,
  pickDateTime,
  pickExpert,
  pickType,
  updateAvailableTypeList,
  pickDuration,
  pickSlot,
} from 'FRONTEND/reducers/bookingSlice';
import { goBackToForm, goToLocationForm, toggleAppointmentModal } from 'FRONTEND/reducers/calendarSlice';
import { searchRequest as expertSearchRequest } from 'FRONTEND/reducers/expertSlice';
import { selectPatientById } from 'FRONTEND/reducers/patientSlice';
import {
  clear as clearSlots,
} from 'FRONTEND/reducers/slotSlice';
import { FormTypes, LOCATION_APPOINTMENT_DEFAULT_DURATION } from 'FRONTEND/utils/constants';
import { CALENDAR_PATH } from 'FRONTEND/utils/routes';
import { PJAX_MAIN_CONTAINER_SELECTOR } from 'LEGACY/constants';

const bookingMiddleware = (store) => (next) => async(action) => {
  switch (action.type) {
    case pickDateTime.toString():
    case updateAvailabilitySuccess.toString(): // INFO: Not sure if this is needed anymore,  but we'll wait for appointment form refacto
    case deleteAvailabilitySuccess.toString():
    case createAvailabilitySuccess.toString(): {
      next(action);
      const { desiredDateTime, selectedType, formType, selectedPatientId } = store.getState().booking;
      if (desiredDateTime != null && formType === FormTypes.GIVEN_SLOT_FORM && selectedPatientId != null) {
        const patient = selectPatientById(store.getState(), selectedPatientId);
        store.dispatch(expertSearchRequest({
          appointmentType: selectedType,
          startDate: desiredDateTime,
          tenantId: patient.tenantId,
          isManaged: false,
        }));
      }
      return;
    }

    case pickExpert.toString(): {
      const state = store.getState();
      if (state.booking.selectedExpertId !== action.payload.id) {
        next(action); // Update selected expert in store first so that the form is not cleared too deeply
        if (state.booking.formType !== FormTypes.GIVEN_SLOT_FORM && state.booking.formType !== FormTypes.LOCATION_FORM && state.booking.formType !== FormTypes.PATIENT_FORM) {
          store.dispatch(clearForm());
        }
        return;
      }
      return next(action);
    }
    case pickSlot.toString(): {
      next(action);
      const { booking, user } = store.getState();
      const isLocationForm = booking.formType === FormTypes.LOCATION_FORM;
      const isPatientForm = booking.formType === FormTypes.PATIENT_FORM;
      const selectedSlot = booking.selectedSlot;
      const tenantId = Object.keys(user.tenantList)[0];

      if (!isLocationForm || selectedSlot == null) {
        store.dispatch(clearSlots());
      }
      if (isPatientForm && selectedSlot != null) {
        store.dispatch(expertSearchRequest({
          appointmentType: booking.selectedType,
          startDate: selectedSlot.startDate,
          tenantId,
          isManaged: false,
          hasPayment: true,
        }));
      }

      return;
    }

    case goBackToForm.toString():
      next(action);
      if (window.location.pathname !== CALENDAR_PATH) {
        // At this point, if isAppointmentModalOpen is true, it means user navigated away from it (to update/create patient).
        // Navigate back to the calendar page, and then open the modal again after the state reset.
        if (store.getState().calendar.isAppointmentModalOpen) {
          $.pjax({ url: CALENDAR_PATH, container: PJAX_MAIN_CONTAINER_SELECTOR });
          store.dispatch(toggleAppointmentModal({ isOpen: true }));
        }
      }
      return;

    case updateAvailableTypeList.toString(): {
      const selectedType = store.getState().booking.selectedType;
      if (action.payload.availableTypeList.length === 1) {
        store.dispatch(pickType({ type: action.payload.availableTypeList[0] }));
      } else if (selectedType && !action.payload.availableTypeList.includes(selectedType)) {
        store.dispatch(pickType({ type: null }));
      }
      return next(action);
    }

    case goToLocationForm.toString():
      store.dispatch(pickDuration({ desiredDuration: LOCATION_APPOINTMENT_DEFAULT_DURATION }));
      return next(action);

    default:
      return next(action);
  }
};

export default bookingMiddleware;
